import React, { FC, useState } from "react";
import { useUpdateUserDataMutation } from "../../api/userAPI";
import Form from "../../components/Form/Form";
import Button from "../../components/Button/Button";
import { ValidatorsE } from "../../components/Form/yupValidations";
import { P } from "../../components/Text/Text";
import { FormFieldT } from "../../models/models";
import { useAppDispatch } from "../../store/hooks";
import { setContactInfoConfirmed } from "../../store/slices/authSlice";
import {
  bindUserDataToToken,
  getLoggedUser,
  getLoggedUserToken,
} from "../../utils/helpers/tokenStorage";
import usePopup from "../../utils/hooks/usePopup";
import showErrorToast from "../../utils/helpers/showErrorToast";

import styles from "./styles.module.scss";

type ContactInfoValidationPopupBodyPropTypes = {
  userItem: any;
};

const ContactInfoValidationPopupBody: FC<
  ContactInfoValidationPopupBodyPropTypes
> = ({ userItem }) => {
  const [updateUserData] = useUpdateUserDataMutation();
  const { removeAllPopups } = usePopup();
  const dispatch = useAppDispatch();
  const [confirmed, setConfirmed] = useState(false);

  const fields: FormFieldT[] = [
    {
      label: "First name",
      validation: ValidatorsE.REQUIRED_STRING,
      defaultValue: userItem?.FirstName,
    },
    {
      label: "Last name",
      validation: ValidatorsE.REQUIRED_STRING,
      defaultValue: userItem?.LastName,
    },
    {
      label: "Email",
      validation: ValidatorsE.EMAIL,
      defaultValue: userItem?.Email,
    },
    {
      label: "Phone number",
      validation: ValidatorsE.PHONE_NUMBER,
      defaultValue: userItem?.PhoneNumber,
    },
  ];

  const handleSubmit = async (data: any) => {
    const body = {
      ...userItem,
      FirstName: data.firstName,
      LastName: data.lastName,
      Email: data.email,
      PhoneNumber: data.phoneNumber,
      ContactInfoConfirmed: true,
    };

    const res: any = await updateUserData(body);

    // Only treat the contact info as confirmed if the server actually accepted the update. A failed
    // PUT must not flip local state, or the popup reappears on every login (the historical bug).
    if (res?.error) {
      showErrorToast();
      return;
    }

    dispatch(setContactInfoConfirmed(true));
    bindUserDataToToken(
      {
        user: {
          ...getLoggedUser().user.user,
          ContactInfoConfirmed: true,
        },
      } as any,
      getLoggedUserToken(),
      true
    );
    removeAllPopups();
  };

  return (
    <div className={styles.popupBodyWrapper}>
      <P>
        Please ensure that your user profile information includes up-to-date
        contact information.
      </P>
      <P>
        Why is it important? These details allow your collaborators to contact
        you if necessary.
      </P>
      <P>
        We are committed to keeping your personal info private and we do not
        pass it to any other third party.
      </P>
      <Form
        fields={fields}
        onSubmit={handleSubmit}
        formID="approve-user-contact-info-form"
        className={styles.formWrapper}
      />
      <Form
        fields={[
          {
            label: "I confirm the contact information is valid",
            type: "checkbox",
            onChange: (v) => setConfirmed(v),
          },
        ]}
        onSubmit={() => {}}
        formID="confirm-contact-info"
      />
      <div className={styles.wrapper}>
        <Button
          form="approve-user-contact-info-form"
          useGlobalLoading
          disabled={!confirmed}
        >
          Approve
        </Button>
      </div>
    </div>
  );
};

export default ContactInfoValidationPopupBody;
